<template>
	<div class="BackTo">
		<van-nav-bar :title="getTitle" :orderby="orderby" left-text="返回" left-arrow fixed placeholder
			@click-left="onClickLeft" z-index="9" />
	</div>
</template>

<script>
	export default {
		name: 'BackTo',
		props: {
			title: { // 文字内容，默认引用路由meta中的title属性
				type: String
			},
			orderby: { // 文字内容，默认引用路由meta中的title属性
				type: Boolean,
				default: false
			},
			url: String,
			query: String
		},
		data() {
			return {

			}
		},
		computed: {
			getTitle() {
				if (this.title && this.title !== '') {
					return this.title
				} else {
					return this.$route.meta.name
				}
			}
		},
		methods: {
			onClickLeft() {
				if (window.history.length <= 1) {
					this.$router.push({
						path: '/'
					})
					return false
				} else {
					if (this.url !== undefined) {
						if (this.query !== undefined) {
							this.$router.push({
								path: this.url,
								query: {
									type: this.query
								}
							})
						} else {
							this.$router.push({
								path: this.url
							})
						}
					} else if (this.orderby) {
						this.$router.go(-2)
					} else {
						this.$router.back()
					}
				}
			}

		}
	}
</script>

<style>

</style>
